type AuthPolicyDictionary = {
  names: {
    signUpSignIn: string,
  },
  authorities: {
    signUpSignIn: {
      authority: string
    }
  },
  authorityDomain: string
};

type AzureB2CAuthConfig = {
  auth: {
    clientId: string,
    authority: string,
    redirectUri: string
    knownAuthorities: Array<string>
  }
};

export const b2cPolicies: AuthPolicyDictionary = {
  names: {
    signUpSignIn: 'B2C_1_ApplicationSigninFlow',
  },
  authorities: {
    signUpSignIn: {
      authority: 'https://zachysb2c.b2clogin.com/zachysb2c.onmicrosoft.com/B2C_1_ApplicationSigninFlow'
    }
  },
  authorityDomain: 'zachysb2c.b2clogin.com'
};

export const msalConfig: AzureB2CAuthConfig = {
  auth: {
    clientId: 'bc51eb3b-4d3d-4a73-9870-bc17ac9649ca',
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: '/'
  }
};

export const apiScope= ['https://zachysb2c.onmicrosoft.com/54ad5741-98a6-4124-85bc-c925b7e86ccb/attribute.search.api.access'];